import Link from 'next/link'

import { MenuProps } from 'antd'
import { LogoutLink } from '@/src/components/specialLinks/LogoutLink/LogoutLink'
import { PhysiciansSectionLink } from '@/src/components/specialLinks/PhysiciansSectionLink/PhysiciansSectionLink'

import { config } from '@fortawesome/fontawesome-svg-core'
import '@fortawesome/fontawesome-svg-core/styles.css'
config.autoAddCss = false
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import '@/src/lib'

export const menuItems: MenuProps['items'] = [
  {
    key: '1',
    icon: <FontAwesomeIcon icon='chevron-right' aria-hidden='true' />,
    label: <PhysiciansSectionLink />,
  },
  { type: 'divider', style: { margin: '10px 20px 10px 20px' } },
  {
    key: '2',
    icon: <FontAwesomeIcon icon='chevron-right' aria-hidden='true' />,
    label: <Link href='/training-guide'>Training Guide</Link>,
  },
  {
    key: '3',
    icon: <FontAwesomeIcon icon='chevron-right' aria-hidden='true' />,
    label: <Link href='/FAQs'>FAQ</Link>,
  },
  {
    key: '4',
    icon: <FontAwesomeIcon icon='chevron-right' aria-hidden='true' />,
    label: <Link href='/contact-us'>Contact Us</Link>,
  },
  { type: 'divider', style: { margin: '10px 20px 10px 20px' } },
  {
    key: '5',
    icon: <FontAwesomeIcon icon='circle-user' aria-hidden='true' size='2xl' />,
    label: (
      <Link href='/my-profile' role='menuitem'>
        My Profile
      </Link>
    ),
    className: 'text-primary',
  },
  {
    key: '6',
    icon: <FontAwesomeIcon icon='right-from-bracket' aria-hidden='true' />,
    label: <LogoutLink />,
  },
]
